import PropTypes from 'prop-types'
import React from 'react'

import { DynamicImageStyled, TubeWrapper } from './styles'

const TubeSwab = ({ path }) => {
  return (
    <TubeWrapper>
      <DynamicImageStyled
        image={`${path}tube_swab`}
        imageSizes={{
          xs: 280,
          md: 540,
        }}
        alt="tube swab"
        fitOption="none"
        imageType="png"
      />
    </TubeWrapper>
  )
}

TubeSwab.propTypes = {
  path: PropTypes.string.isRequired,
}

export default TubeSwab
